import { Component } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import {NavController, NavParams, ViewController} from 'ionic-angular';

import { Data } from '../../providers/providers';
import * as _ from 'lodash';

@Component({
  selector: 'page-thinning-dataset-edit',
  templateUrl: 'thinning-dataset-edit.html'
})
export class ThinningDatasetEditPage {

  dataset: any;
  isReadyToSave: boolean;
  item: any;
  form: FormGroup;
  target: number;
  tree_count: number;
  potential: number;
  average_clusters_counted: number;

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              public navParams: NavParams,
              public data: Data)
  {
    this.dataset = this.navParams.get('dataset');

    let group = {
      id: new FormControl(this.dataset.id, null), // not shown in view
      tree_count: new FormControl(this.dataset.tree_count, Validators.required),
      cluster_count: new FormControl(this.dataset.cluster_count, Validators.required),
      flower_count: new FormControl(this.dataset.flower_count, Validators.required),
      clusters_counted: new FormControl(),
      clusters_counted_per_tree: new FormControl(this.dataset.clusters_counted_per_tree, Validators.required),
      target_fruit_per_tree: new FormControl(this.dataset.target_fruit_per_tree, Validators.required),
      potential_fruit_per_tree: new FormControl(this.dataset.potential_fruit_per_tree, Validators.required),
    };

    for (let i = 1; i <= this.dataset.tree_count; i++) {
      group[`clusters_counted_${i}`] = new FormControl(this.dataset[`clusters_counted_${i}`]);
    }

    this.form = new FormGroup(group);

    // these shadow the corresponding fields on the form, so we can use them in the reference table
    this.target = this.dataset.target_fruit_per_tree;
    this.tree_count = this.dataset.tree_count;
    this.updateAverage();
    this.updatePotential();

    // Watch the form for changes, and
    this.form.valueChanges.subscribe((v) => {
      this.updateAverage();
      this.updatePotential();
      this.isReadyToSave = this.form.valid;
    });
  }

  updateAverage() {
    let clusters_counted = [];
    for (let i = 1; i <= this.form.value['tree_count']; i++) {
      let count = this.form.value[`clusters_counted_${i}`];
      if (!count) {
        count = 0;
      }
      clusters_counted.push(_.toNumber(count));
    }
    // console.log(clusters_counted);

    this.average_clusters_counted = _.mean(clusters_counted);
  }

  updatePotential() {
    this.potential = this.form.value['flower_count'] * this.average_clusters_counted;
  }

  /**
   * The user cancelled, so we dismiss without sending data back.
   */
  cancel() {
    this.viewCtrl.dismiss();
  }

  /**
   * The user is done and wants to create the item, so return it
   * back to the presenter.
   */
  done() {
    if (!this.form.valid) { return; }
    this.viewCtrl.dismiss(this.form.value);
  }
}



// WEBPACK FOOTER //
// ./src/pages/thinning-dataset-edit/thinning-dataset-edit.ts